import React from 'react';
import { Unity, useUnityContext } from 'react-unity-webgl';
import Loader from '@/components/Loader.jsx';
import { twMerge } from 'tailwind-merge';

const config = JSON.parse(document.getElementById('unity-config').textContent);

function App() {
  const { unityProvider, loadingProgression, isLoaded } = useUnityContext({
    loaderUrl: config.loaderUrl,
    dataUrl: config.dataUrl,
    frameworkUrl: config.frameworkUrl,
    codeUrl: config.codeUrl,
  });

  const remap = (value, inMin, inMax, outMin, outMax) => ((value - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;

  return (
    <div className="relative size-full bg-[#1a1a1a]">
      {!isLoaded && (
        <div className="absolute inset-[30%]">
          <Loader
            pct={remap(loadingProgression, 0, 0.9, 0, 1)}
            className="absolute size-full"
          />
        </div>
      )}
      <Unity
        className={twMerge('absolute inset-0 size-full', isLoaded ? 'block' : 'hidden')}
        unityProvider={unityProvider}
      />
    </div>
  );
}

export default App;
